import styled from 'styled-components';

import { colors } from '../../constants';

interface IProps {
    width: number;
}

export const LineForeground = styled.div<IProps>`
    background: ${colors.greenDark};
    height: 3px;
    position: absolute;
    width: ${(props) => `${props.width}%`};
    top: 50%;
    transform: translateY(-50%);
`;
